import $ from 'jquery'; // we need to access this version of jquery to use the prototype methods Shopify adds (like getJSON)

module.exports = function(options) {
  //
  //   Private Vars
  //
  //////////////////////////////////////////////////////////////////////

  const self = {
    cartCount: $('[data-cart-count]')
  };

  
  //
  //   Private Methods
  //
  //////////////////////////////////////////////////////////////////////

  const _init = function() {
    if (self.cartCount.length === 0) return;
    
    _displayCount();
  };

  const _displayCount = function() {
    $.getJSON('/cart', function(cart) {
      let count = 0;

      cart.items.forEach(function(item, idx) {
        count += item.quantity
      });

      if (count > 0) {
        self.cartCount.html(count).addClass('is-active');
      } else {
        self.cartCount.html('').removeClass('is-active');
      }
    });
  };

 
  //
  //   Public Methods
  //
  //////////////////////////////////////////////////////////////////////
  
  self.update = function() {
     _displayCount();
  };

  
  //
  //   Initialize
  //
  //////////////////////////////////////////////////////////////////////

  _init();

  // Return the Object
  return self;
}